"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayObserver = void 0;
var custom_observer_1 = require("./custom-observer");
/**
 * A subclass of Vue's internal `Observer` class for arrays, which uses observable
 * array events rather than property walking and rewriting
 */
var ArrayObserver = /** @class */ (function (_super) {
    __extends(ArrayObserver, _super);
    function ArrayObserver(value, shallow, mock) {
        if (shallow === void 0) { shallow = false; }
        if (mock === void 0) { mock = false; }
        return _super.call(this, value, shallow, mock) || this;
    }
    ArrayObserver.prototype.ensureObservable = function () {
        if (this._observable === true) {
            return;
        }
        this.value.changed.subscribe(this._onChange.bind(this));
        this._observable = true;
    };
    ArrayObserver.prototype._onChange = function () {
        this.dep.notify();
    };
    return ArrayObserver;
}(custom_observer_1.CustomObserver));
exports.ArrayObserver = ArrayObserver;
